import { render, staticRenderFns } from "./BanksListItem.vue?vue&type=template&id=8b59e0c6&"
import script from "./BanksListItem.vue?vue&type=script&lang=js&"
export * from "./BanksListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports